export enum PlatformStatisticsKey {
  ID = 'id',
  NAME = 'name',
  SERVER = 'server',
  ACCOUNT_GROUP = 'accountGroupName',
  CURRENCY = 'currencyId',
  PLATFORM_TYPE = 'platformTypeName',
  ACCOUNT_TYPE = 'accountType',
  STATUS = 'statusName',
  BALANCE = 'balance',
  EQUITY = 'equity',
  USED_MARGIN = 'usedMargin',
  MARGIN_LEVEL = 'marginLevel',
  FREE_MARGIN = 'freeMargin',
  TOTAL_NUMBER_OF_DEPOSITS = 'totalNumberOfDeposits',
  TOTAL_DEPOSIT_AMOUNT = 'totalDepositAmount',
  FIRST_DEPOSIT = 'firstDeposit',
  LAST_DEPOSIT = 'lastDeposit',
  TOTAL_NUMBER_OF_WITHDRAWALS = 'totalNumberOfWithdrawals',
  TOTAL_WITHDRAWAL_AMOUNT = 'totalWithdrawalAmount',
  FIRST_WITHDRAWAL = 'firstWithdrawal',
  LAST_WITHDRAWAL = 'lastWithdrawal',
  TOTAL_NUMBER_OF_CLOSED_TRADES = 'totalNumberOfClosedTrades',
  TOTAL_CLOSED_LOTS = 'totalClosedLots',
  TOTAL_CLOSED_PROFIT = 'totalClosedProfit',
  TOTAL_NUMBER_OF_OPEN_TRADES = 'totalNumberOfOpenTrades',
  TOTAL_OPEN_LOTS = 'totalOpenLots',
  TOTAL_OPEN_PROFIT = 'totalOpenProfit',
  TOTAL_COMMISSIONS = 'totalCommissions',
  TOTAL_SWAPS = 'totalSwaps',
  FIRST_TRADE = 'firstTrade',
  LAST_TRADE = 'lastTrade',
}
